const writeAReviewDevMode = false;
const writeAReviewModal = document.getElementById("royer-write-a-review-modal");
const writeAReviewModalLoader = document.getElementById("write-a-review-modal-loader");
const writeAReviewSuccessToast= document.getElementById("writeAReviewSuccessToast");
const writeAReviewErrorToast= document.getElementById("writeAReviewErrorToast");
const writeAReviewRatingWrapper = document.getElementById("review-rating-input-wrapper");
const writeAReviewSubmitButton = document.querySelector('.review-submit-button');
const writeAReviewPictureInput = document.getElementById('review-pictures');
const writeAReviewPreviewContainer = document.getElementById('review-picture-preview');

const writeAReviewCountrySelect = document.getElementById('review-country');
const writeAReviewRegionWrapper = document.querySelector('.review-region-wrapper');
const writeAReviewRegionSelect = document.getElementById('review-region');

let writeAReviewBootstrapModal;
  
let writeAReviewSuccessToastBootstrap;
let writeAReviewErrorToastBootstrap;

document.addEventListener("DOMContentLoaded", (event) => {
  writeAReviewBootstrapModal = new bootstrap.Modal(writeAReviewModal);
  writeAReviewSuccessToastBootstrap = bootstrap.Toast.getOrCreateInstance(writeAReviewSuccessToast, {delay: 5000});
  writeAReviewErrorToastBootstrap = bootstrap.Toast.getOrCreateInstance(writeAReviewErrorToast, {delay: 5000});
});
  
writeAReviewRatingWrapper.addEventListener("mousemove", (ev) => {
  const totalWidth = writeAReviewRatingWrapper.clientWidth;
  const oneStarWidth = totalWidth / writeAReviewRatingWrapper.children.length;
  
  const rating = Math.min(Math.max(Math.ceil((ev.layerX - ev.offsetX - writeAReviewRatingWrapper.offsetLeft) / oneStarWidth) + 1, 1), 5);

  updateStars(rating);
});
writeAReviewRatingWrapper.addEventListener("mouseleave", (ev) => {
  let rating = writeAReviewRatingWrapper.closest(".review-input-wrapper").querySelector(".review-input").value;
  if (rating == "") rating = 0;

  updateStars(rating);
});

writeAReviewRatingWrapper.addEventListener("click", (ev) => {
  const totalWidth = writeAReviewRatingWrapper.clientWidth;
  const oneStarWidth = totalWidth / writeAReviewRatingWrapper.children.length;
  
  const rating = Math.min(Math.max(Math.ceil((ev.layerX - ev.offsetX - writeAReviewRatingWrapper.offsetLeft) / oneStarWidth) + 1, 1), 5);

  const ratingInput = writeAReviewRatingWrapper.closest(".review-input-wrapper").querySelector(".review-input");
  ratingInput.value = rating;
  removeErrors(ratingInput);
});

writeAReviewCountrySelect.addEventListener("change", () => updateWriteAReviewVisibleRegions());

// Submit button functionality
writeAReviewSubmitButton.addEventListener('click', () => {
  const isValid = checkInputValidation();
  if (!isValid) return;

  //show the loader
  writeAReviewModalLoader.classList.add("show");

  const ratingInput = document.getElementById("review-rating");
  const titleInput = document.getElementById("review-title");
  const bodyInput = document.getElementById("review-body");
  const pictureInputs = Array.from(document.querySelectorAll(".review-picture"));
  const questionsInput = Array.from(document.getElementById("questions-section").querySelectorAll(".review-input-wrapper .review-input"));
  const nameInput = document.getElementById("review-name");
  const emailInput = document.getElementById("review-email");

  const review = {
    site_no: siteNb,
    country: writeAReviewCountrySelect.value,
    region: writeAReviewRegionSelect.value == "" ? null : writeAReviewRegionSelect.value,
    email: emailInput.value,
    name: nameInput.value,
    rating: parseInt(ratingInput.value),
    title: titleInput.value == "" ? null : titleInput.value,
    body: bodyInput.value,
    questions: questionsInput.map(input => { return {
      question_id: parseInt(input.dataset.questionId),
      question_option_value: parseInt(input.value)
    }}),
    source: "web",
    shopify_product_id: product.id,
    product_reference: product.title,
    product_handle: product.handle
  };

  const formData = new FormData();
  formData.append('review', JSON.stringify(review));
  if (pictureInputs.every(pictureInput => pictureInput.files.length === 0))
    formData.append("files", null);
  else
    pictureInputs.forEach(pictureInput => {
      Array.from(pictureInput.files).forEach((file) => {
        formData.append("files", file);
      });
    });

  const prodUrl = "https://api3.royer.com/api/reviews/create-review";
  const devUrl = "https://localhost:44318/api/reviews/create-review";

  const postUrl = writeAReviewDevMode ? devUrl : prodUrl;

  const myHeaders = new Headers();
  myHeaders.append('Authorization', "Basic TVZobGVsa3FScDk0TlI2NTFseXM6c2ZIUnpVT1FGcEcxclJ6WGx1bE0=");

  let requestOptions = {
    method: 'POST',
    headers: myHeaders,
    redirect: 'follow',
    scheme: 'https',
    mode: 'cors',
    cache: 'no-cache',
    body: formData
  };

  fetch(postUrl, requestOptions)
    .then(response => response.text())
    .then(result => {
      //Hide the loader again
      writeAReviewModalLoader.classList.remove("show");
      let createRequestResult = JSON.parse(result);
      if (createRequestResult) {
        writeAReviewBootstrapModal.hide();
        writeAReviewSuccessToastBootstrap.show();
      }
      else {
        writeAReviewErrorToastBootstrap.show();
      }
    })
    .catch(error => {
      //Hide the loader again
      writeAReviewModalLoader.classList.remove("show");
      writeAReviewErrorToastBootstrap.show();
      console.log(error)
    });
});

// Function to handle image uploads and show thumbnails
writeAReviewPictureInput.addEventListener('change', (event) => {
  // Clear previous thumbnails
  writeAReviewPreviewContainer.innerHTML = '';

  // Get the selected files
  const files = event.target.files;

  // Limit to 4 images
  const maxFiles = 4;
  const numFiles = Math.min(files.length, maxFiles);

  for (let i = 0; i < numFiles; i++) {
    const file = files[i];

    // Ensure it's an image file
    if (file.type.startsWith('image/')) {
      const reader = new FileReader();

      // Create a thumbnail once the file is loaded
      reader.onload = function (e) {
        const img = document.createElement('img');
        img.src = e.target.result;
        img.alt = `Uploaded Image ${i + 1}`;
        img.className = 'review-thumbnail';
        writeAReviewPreviewContainer.appendChild(img);
      };

      // Read the file as a data URL
      reader.readAsDataURL(file);
    }
  }

  // Show a message if too many files are selected
  if (files.length > maxFiles) {
    alert(`You can only upload up to ${maxFiles} images.`);
  }
});

function questionChoiceClicked(btnEl){
  const selectedClassname = "checked";
  //If it's already selected then do nothing
  if (btnEl.classList.contains(selectedClassname)){
    //If it can have multiple value then deselect the option
    if (isMultiple) btn.classList.remove(selectedClassname);
    //Do nothing else
    return;
  }
  
  const questionWrapper = btnEl.closest(".question-wrapper");
  const isMultiple = questionWrapper.dataset.multiple == "true";
  
  const selectInput = questionWrapper.querySelector("select");

  const questionOptionValue = btnEl.dataset.questionOptionValue;
  selectInput.value = questionOptionValue;
  removeErrors(selectInput);
  
  Array.from(questionWrapper.querySelectorAll("button")).forEach(btn => btn.classList.remove(selectedClassname));
  btnEl.classList.add(selectedClassname);
}

function checkInputValidation(showErrors = true){
  let invalidInputWrappers = [];
  
  Array.from(writeAReviewModal.querySelectorAll(".review-input-wrapper")).forEach(inputWrapper => {
    const input = inputWrapper.querySelector(".review-input");
    const requiredInputErrorMsk = inputWrapper.querySelector("[data-required-error]");
    const emailFormatErrorMsk = inputWrapper.querySelector("[data-email-format-error]");
    let isValid = true;
    
    if (requiredInputErrorMsk && !input.value){
      if (showErrors)
        requiredInputErrorMsk.classList.remove("invisible");
      isValid = false;
    }
    else if (emailFormatErrorMsk && (!(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(input.value)))){
      if (showErrors){
        if (requiredInputErrorMsk) requiredInputErrorMsk.classList.add("d-none")
        emailFormatErrorMsk.classList.remove("invisible");
        emailFormatErrorMsk.classList.remove("d-none");
      }
      isValid = false;
    }

    if (!isValid) invalidInputWrappers.push(inputWrapper);
  });

  //scrollToHighestElement is from royer-utilities-functions.js
  if (showErrors && invalidInputWrappers.length != 0) scrollToHighestElement(invalidInputWrappers);
  
  return invalidInputWrappers.length == 0;
}

function removeErrors(input){
  const inputWrapper = input.closest(".review-input-wrapper");
  const requiredErrorMsg = inputWrapper.querySelector("[data-required-error]");
  const emailFormatErrorMsg = inputWrapper.querySelector("[data-email-format-error]");
  
  requiredErrorMsg?.classList.add("invisible");
  if (emailFormatErrorMsg) requiredErrorMsg?.classList.remove("d-none");
  
  if (requiredErrorMsg && emailFormatErrorMsg)
    emailFormatErrorMsg?.classList.add("d-none");
  else if (!requiredErrorMsg && emailFormatErrorMsg)
    emailFormatErrorMsg?.classList.add("invisible");
}

function updateStars(rating, wrapper = writeAReviewRatingWrapper){
  for (let i = 0; i < rating; i++){
    const star = wrapper.children[i];
    if (!star.classList.contains("full")) star.classList.add("full");
  }
  for (let i = rating; i<5;i++){
    const star = wrapper.children[i];
    if (star.classList.contains("full")) star.classList.remove("full");
  }
}

function updateWriteAReviewVisibleRegions(){
  const selectedCountryCode = writeAReviewCountrySelect.value;

  //Always unselect the region on country change
  writeAReviewRegionSelect.value = "";
  
  //Getting all the actual options (removing the default no answer option)
  const options = Array.from(writeAReviewRegionSelect.options).filter(option => option.value !== "");
  
  options.forEach(option => {
    if (option.dataset.country != selectedCountryCode){
      option.classList.add("d-none");
      option.disabled = true;
    }
    else{
      option.classList.remove("d-none");
      option.disabled = false;
    }
  });

  //only show the correct label for the currently selected country
  Array.from(writeAReviewRegionWrapper.querySelectorAll("label")).forEach(label => {
    if (label.dataset.country == selectedCountryCode) label.classList.remove("d-none");
    else  label.classList.add("d-none");
  });

  //If all the options are disabled then hide the region wrapper
  if (options.every(option => option.disabled)) writeAReviewRegionWrapper.classList.add("d-none");
  //If some options are visible then show the region wrapper
  else writeAReviewRegionWrapper.classList.remove("d-none");
}